/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import RewardsFeedback from 'components/shared/rewardsfeedback/rewardsfeedback';



/* ========== ~~~~~~~~~~ REWARDS : MESSAGES : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, contentData, settings, rewards }, { contentId, frame }) => ({
    frameStatus: contentStatus[contentId]['uniqueState']['frameStatus'][frame],
    frameData: contentData[contentId]['data'][frame],
    currentContentSettings: settings.contentSettings[contentId],
    rewardsEnabled: rewards.settings.enabled,
    rewardsPointValues: rewards.settings.pointValues,
    rewardsPermitted: rewards.status.rewardsPermitted,
    enlargedFont: settings.embedSettings.enlargedFont
});

// // map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(RewardsFeedback);
